import ActionOutcome from '@eversports/react-components/patterns/ActionOutcome'
import Heading from '@eversports/react-components/primitives/Heading'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { Localized } from '../localization/react'

const ValidationFailed: React.FC<React.PropsWithChildren<unknown>> = () => (
  <ActionOutcome type="error" justifyContent="center" flexGrow={1}>
    <Heading data-testid="validation-failed" is="h1">
      <Localized id="validation-failed-heading" />
    </Heading>
    <Text>
      <Localized id="validation-failed-subheading" />
    </Text>
  </ActionOutcome>
)

export { ValidationFailed }
